// eslint-disable-next-line object-curly-newline

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Логин',
    value: 'school_code',
    sortable: false,
  },
  {
    text: 'Пользователь',
    value: 'school_name',
    sortable: false,
  },
  {
    text: 'Статус',
    value: 'status',
    sortable: false,
    width: 120,
    field: () => 'Не приступил',
  },
])
